<template>
    <div class="container-fluid login-bg" >
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
        <div class="row">
            <div class="col-lg-6 offset-lg-3">
                <div class="card main-card" style="margin-bottom: 6vh;">
                     <div class="card-body">
                        <div class="card-text">
                            <h3>Register for a HLS Account</h3>
                            <div v-if="serverErrors.length > 0" class="alert alert-danger" role="alert">
                                <ul>
                                    <li v-for="(item, index) in serverErrors" :key="index">{{item}}</li>
                                </ul>
                            </div>
                            <div class="form-group form-">
                                <label for="email">Email</label>
                                <input type="email" class="form-control form-control-sm" name="email" v-model="email" v-validate="'required|email'" :class="{'has-error': errors.has('email')}" placeholder="Email">
                                <div v-if="errors.has('email')" class="alert alert-danger mt-1">
                                    {{ errors.first('email') }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="first name">First Name</label>
                                <input type="text" class="form-control form-control-sm" name="first name" v-model="firstName" v-validate="'required'" :class="{'has-error': errors.has('first name')}" placeholder="First Name">
                                <div v-if="errors.has('first name')" class="alert alert-danger mt-1">
                                    {{ errors.first('first name') }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="last name">Last Name</label>
                                <input type="text" class="form-control form-control-sm" name="last name" v-model="lastName" v-validate="'required'" :class="{'has-error': errors.has('last name')}" placeholder="Last Name">
                                <div v-if="errors.has('last name')" class="alert alert-danger mt-1">
                                    {{ errors.first('last name') }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="employee">Are you the employee or spouse?</label>
                                <br>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" id="employee" value="employee" v-model="spouseOrEmployee">
                                    <label class="form-check-label" for="employee">Employee</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" id="spouse" value="spouse" v-model="spouseOrEmployee">
                                    <label class="form-check-label" for="spouse">Spouse</label>
                                </div>
                            </div>
                            <div v-if="spouseOrEmployee === 'spouse'"  class="form-group"> 
                                <label for="spouse name">Your Spouse's Name</label>
                                <input type="text" class="form-control form-control-sm" name="spouse name" v-model="spouseName" v-validate="spouseOrEmployee === 'spouse' ? 'required' : ''" :class="{'has-error': errors.has('spouse name')}" placeholder="Your Spouse Name">
                                <div v-if="errors.has('spouse name')" class="alert alert-danger mt-1">
                                    {{ errors.first('spouse name') }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="password">Password</label>
                                <input v-model="password" v-validate="'required|min:8|verify_password'" :class="{'has-error': errors.has('password')}" name="password" type="password" class="form-control form-control-sm" placeholder="Password" ref="password">
                                <div v-if="errors.has('password')" class="alert alert-danger mt-1">
                                    {{ errors.first('password') }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="confirmpass">Confirm Password</label>
                                <input v-model="confirmPassword" v-validate="'required|confirmed:password'" :class="{'has-error': errors.has('password_confirmation')}" name="password_confirmation" type="password" class="form-control form-control-sm" placeholder="Confirm Password" data-vv-as="password">
                                <div v-if="errors.has('password_confirmation')" class="alert alert-danger mt-1">
                                    {{ errors.first('password_confirmation') }}
                                </div>
                            </div>
                            <button v-on:click="notifyPrivacy" type="submit" class="btn vesta-gray-btn col-lg-4 col-sm-12">Create Account</button>
                            <div>
                                <b-modal ref="my-modal" size="lg" centered  hide-footer title="Privacy Act Statement">
                                    <div class="d-block">
                                        <h6>Authority:</h6>
                                        <p>
                                            5 U.S.C. 301, "Departmental Regulations"; National Security Act of 1947, as amended, 50 U.S.C. 401 et seq., "Congressional declaration of purpose"; E.O. 9397, "Federal Agency Use of Social Security Numbers"; and E.O. 12333, as amended, "United States Intelligence Activities."
                                        </p>
                                        <h6>Purpose(s):</h6>
                                        <p>
                                        This information will be used to manage, supervise, and administer agency personnel support programs relating to personnel management, official travel, timecards and leave records, awards, training, loan of property, security, emergency recall rosters and contact information; to support organizational and personnel reporting requirements; to support organizational and strategic planning and workforce modeling; to support workplace violence protection programs; to support diversity initiatives; and to respond to personnel or related taskings.
                                        </p>
                                        <h6>Routine uses:</h6>
                                        <p>
                                        In addition to the statutory disclosures permitted under 5 U.S.C. 552a(b) of the Privacy Act, under these records may specifically be disclosed outside the agency as a routine use pursuant to 5 U.S.C. 552a(b)(3). Disclosures may be pursuant to DOD 'Blanket Routines Uses' apply to this system.
                                        </p>
                                        <h6>Disclosures:</h6>
                                        <p>
                                        Disclosure of information is voluntary; however, failure to provide complete information may delay processing of the form.
                                        </p>
                                    </div>
                                    <b-button class="mt-3" variant="primary" block v-on:click="createAccount">I agree and accept</b-button>
                                    <b-button class="mt-3" variant="secondary" block v-on:click="hideModal">Cancel</b-button>
                                </b-modal>
                            </div>
                        </div>
                     </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style>

.has-error {
    border-color: red;
}
</style>

<script>
/* eslint-disable */
import axios from 'axios'
import Loading from 'vue-loading-overlay';

import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    data() {
        return {
            serverErrors: [],
            email: '',
            firstName: '',
            lastName: '',
            password: '',
            confirmPassword: '',
            spouseName: '',
            spouseOrEmployee: 'employee',
            isLoading: false
        }
    },
    components: {
      Loading
    },
    methods: {
        createAccount: function (e) {
            this.hideModal();
            this.serverErrors = [];
            this.isLoading = true;
            const self = this;
            this.$validator
                .validateAll()
                .then(function (passValidation) {
                    if (passValidation) {
                        axios.post('/api/Account/Register', {
                            Email: self.email,
                            Password: self.password,
                            ConfirmPassword: self.confirmPassword,
                            LastName: self.lastName,
                            FirstName: self.firstName,
                            CompanyName: self.companyName,
                            SpouseName: self.spouseName,
                            GovEmployee: self.govEmployee
                        }).then(function (response) {
                            self.isLoading = false;
                            if (response.data.status_code === 200) {
                                self.$router.push('RegisterSuccess');
                            } else {
                                if (response.data.errors.length > 0) {
                                    response.data.errors.forEach(item => {
                                        self.serverErrors.push(item.error);
                                    });
                                } else {
                                    self.serverErrors.push('An error occurred during the registration process');
                                }
                            }
                        }).catch(function (resp) {
                            self.isLoading = false;
                            self.serverErrors.push('An error occurred during the registration process');
                        });
                    } else {
                        self.isLoading = false;
                        e.preventDefault();
                    }
                })
                .catch(function () {
                    self.isLoading = false;
                    e.preventDefault();
                });
        },

        notifyPrivacy: function (){
            this.$refs['my-modal'].show()
        },
        hideModal() {
            this.$refs['my-modal'].hide()
        }
    }
}
</script>
